import { css } from 'linaria';
import { ArrowLink } from 'components/arrow-link/arrow-link';
import VisibilitySensor from 'components/visibility-sensor/visibility-sensor';
import { PREMIUM_URL } from 'common/constants';
import { PremiumIcon } from 'components/icons/PremiumIcon';
import { Trans } from 'next-i18next';
const upsellWrapper = "uo1llzw";
export const TagUpsell = ({
  onVisible
}) => {
  const handleVisible = () => onVisible('suggested-tags.upgrade-link');

  return <VisibilitySensor onVisible={handleVisible}>
      <div className={upsellWrapper}>
        <p>
          <PremiumIcon />
          <Trans i18nKey="tags:tag-stories-faster">
            Tag stories faster than ever—get tag suggestions with
          </Trans>
        </p>
        <ArrowLink id="suggested-tags.upgrade-link" dataCy="suggested-tags-upgrade" margin="10px 0" href={`${PREMIUM_URL}&utm_campaign=suggested-tags`} target="_blank">
          <Trans i18nKey="tags:pocket-premium">Pocket Premium</Trans>
        </ArrowLink>
      </div>
    </VisibilitySensor>;
};

require("./tag.upsell.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag.upsell.js");